import { BODY_SHAPE_OPTIONS } from '../../options/BodyShape/BODY_SHAPE_OPTIONS';
import { ScreenAboutLook } from '../OwnAI/screens/AboutLook';
import { ScreenAge } from '../OwnAI/screens/Age';
import { ScreenBodyShape } from '../OwnAI/screens/BodyShape';
import { ScreenCommunicate } from '../OwnAI/screens/Communicate';
import { ScreenEmail } from '../OwnAI/screens/Email';
import { ScreenEthnicity } from '../OwnAI/screens/Ethnicity';
import { ScreenFindAi } from '../OwnAI/screens/FindAi';
import { ScreenHairColor } from '../OwnAI/screens/HairColor';
import { ScreenInteraction } from '../OwnAI/screens/Interaction';
import { ScreenMajorTurnOff } from '../OwnAI/screens/MajorTurnOff';
import { ScreenName } from '../OwnAI/screens/Name';
import { ScreenObedience } from '../OwnAI/screens/Obedience';
import { ScreenPersonality } from '../OwnAI/screens/Personality';
import { ScreenSecurity } from '../OwnAI/screens/Security';
import { ScreenSettingUpProfile } from '../OwnAI/screens/SettingUpProfile';
import { ScreenGreetAITails } from '../screens/GreetAITails';

import { LayoutDataType } from './types';

export const layoutSteps = {
  greet_ai_tails: {
    component: ScreenGreetAITails,
    images: [],
  },
  age: {
    component: ScreenAge,
    images: [],
  },
  ethnicity: {
    component: ScreenEthnicity,
    images: [],
  },
  find_ai: {
    component: ScreenFindAi,
    images: [],
  },
  body_shape: {
    component: ScreenBodyShape,
    images: BODY_SHAPE_OPTIONS.map(
      (option) =>
        `https://d3hhlnlnie19wm.cloudfront.net/web-onb/assets/layout-own-ai/body_shape/${option.id}.png`,
    ),
  },
  hair_color: {
    component: ScreenHairColor,
    images: [],
  },
  about_look: {
    component: ScreenAboutLook,
    images: [
      'https://d3hhlnlnie19wm.cloudfront.net/web-onb/assets/layout-own-ai/bg-about-look.png',
    ],
  },
  interactions: {
    component: ScreenInteraction,
    images: [],
  },
  communicate: {
    component: ScreenCommunicate,
    images: [],
  },
  obedience: {
    component: ScreenObedience,
    images: [],
  },
  personality: {
    component: ScreenPersonality,
    images: [],
  },
  major_turn_off: {
    component: ScreenMajorTurnOff,
    images: [
      'https://d3hhlnlnie19wm.cloudfront.net/web-onb/assets/layout-own-ai/modal_send_photos.png',
    ],
  },
  security: {
    component: ScreenSecurity,
    images: [],
  },
  name: {
    component: ScreenName,
    images: [],
  },
  setting_up_profile: {
    component: ScreenSettingUpProfile,
    images: [],
  },
  email: {
    component: ScreenEmail,
    images: [],
  },
};

export const layoutStepsKeys = Object.keys(layoutSteps);

export const layoutDataDefault: LayoutDataType = {
  age: null,
  ethnicity: null,
  body_shape: null,
  hair_color: null,
  interaction: null,
  communicate: null,
  obedience: null,
  personality: {
    shy_dominant: 50,
    serious_flirty: 50,
    logical_emotional: 50,
    affectionate_independent: 50,
  },
  major_turn_off: null,
  send_photos: null,
  name: '',
  characters: [],
  email: '',
};

// Category constants - not used, already hardcoded in AboutLook screen
export const HARDCODED_CATEGORIES = [];
